import { ApiStatus } from '../../types';

import { personalDetailsDefaultContent, PersonalDetailsState } from './personalDetailsTypes';

export const initialStatePersonalDetails: PersonalDetailsState = {
    content: personalDetailsDefaultContent,
    getPersonalDetailsApiStatus: ApiStatus.Idle,
    deletePersonalDetailsApiStatus: ApiStatus.Idle,
    apiEndpoints: { getPersonalDetailsUrl: '/getPersonalDetails' },
    personalInfo: { address: '' },
    checkboxStates: {
        isEmailChecked: false,
        isMobileChecked: false,
        isAddressChecked: false,
    },
    isResidencyEditMode: false,
    driverLicenceIsEditMode: false,
};
